import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiArrowRight, FiGlobe } = FiIcons;

const Login = ({ onLogin }) => {
  const [name, setName] = useState('');
  const [selectedAvatar, setSelectedAvatar] = useState('🦁');
  const [error, setError] = useState('');

  const avatars = [
    { id: 'lion', emoji: '🦁', label: 'Lion' },
    { id: 'coffee', emoji: '☕', label: 'Coffee' },
    { id: 'sun', emoji: '☀️', label: 'Sun' },
    { id: 'flower', emoji: '🌼', label: 'Flower' },
    { id: 'mountain', emoji: '⛰️', label: 'Mountain' },
    { id: 'runner', emoji: '🏃', label: 'Runner' },
    { id: 'star', emoji: '⭐', label: 'Star' },
    { id: 'heart', emoji: '💚', label: 'Heart' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }
    onLogin({ name, avatar: selectedAvatar });
  };

  return (
    <div className="w-full h-full flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4 animate-in fade-in duration-500">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden border border-white/20 transform scale-100 transition-all">
        
        {/* Header Section */}
        <div className="bg-gradient-to-r from-green-700 to-emerald-700 p-8 text-center text-white relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('/grid.svg')]"></div>
          <div className="relative z-10">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-md rounded-2xl mx-auto flex items-center justify-center text-3xl mb-4 shadow-lg border border-white/30">
              <span className="font-amharic">ግ</span>
            </div>
            <h1 className="text-2xl font-bold mb-1">Welcome Student!</h1>
            <p className="text-green-100 text-sm">Start your Amharic journey</p>
          </div>
        </div>

        {/* Form Section */}
        <div className="p-8 bg-white">
          <form onSubmit={handleSubmit} className="space-y-6">
            
            {/* Name Input */}
            <div className="space-y-2">
              <label className="block text-sm font-bold text-gray-700">What's your name?</label>
              <div className="relative">
                <SafeIcon icon={FiUser} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input 
                  type="text" 
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setError('');
                  }}
                  className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                  placeholder="Enter your name"
                  maxLength={20}
                  autoFocus
                />
              </div>
              {error && <p className="text-red-500 text-xs pl-1">{error}</p>}
            </div>

            {/* Avatar Selection */}
            <div className="space-y-3">
              <label className="block text-sm font-bold text-gray-700">Choose your avatar</label>
              <div className="grid grid-cols-4 gap-3">
                {avatars.map((av) => (
                  <button
                    key={av.id}
                    type="button"
                    onClick={() => setSelectedAvatar(av.emoji)}
                    className={`aspect-square rounded-xl flex items-center justify-center text-2xl transition-all ${
                      selectedAvatar === av.emoji 
                        ? 'bg-green-100 border-2 border-green-500 shadow-md scale-105' 
                        : 'bg-gray-50 border border-gray-100 hover:bg-gray-100'
                    }`}
                    title={av.label}
                  >
                    {av.emoji}
                  </button>
                ))}
              </div>
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="w-full py-4 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-bold shadow-lg shadow-green-200 hover:shadow-xl hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2 group"
            >
              Start Learning
              <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-xs text-gray-400 flex items-center justify-center gap-1">
              <SafeIcon icon={FiGlobe} />
              Learn Language • Learn Culture
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;